export default (theme) => ({
  container: {
    padding: "20px 30px",
    borderBottom: "1px solid #c5c5c7"
  },
});
